import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Button as PrimeButton } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { FilterMatchMode } from "primereact/api";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";

import {
    SERVICE_LOCATION, GET_PROCESSED_PAYAPP_MEASURESCOUNT_BY_SITE, SEND_INVOICE,
    GET_PROCESSED_PAYAPP_MEASURES_FOR_SITE, DOWNLOAD_INVOICE_WITH_DOWNLOAD_OPTIONS
} from "../constants/endpoints";

import { INVOICE_DOWNLOAD_TYPES, RECIPIENT_TYPES } from "../constants/newBuildConstants";

import { INVOICE_DOWNLOAD_SUCCESS } from "../constants/errors";

import "./../assets/styles/table.css";
import "./../assets/styles/worksheets.css";

const ProcessedPayApps = (props) => {
    const toast = useRef(null);

    const { data } = props;
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";

    const [loading, setLoading] = useState(false);
    const [sitesData, setSitesData] = useState(null);
    const [selectedSite, setSelectedSite] = useState(null);
    const [showMeasures, setShowMeasures] = useState(false);
    const [measuresData, setMeasuresData] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [minToDate, setMinToDate] = useState(null);
    const [disableGoButton, setDisableGoButton] = useState(null);
    const [selectedDownloadType, setSelectedDownloadType] = useState(null);
    const [downloadTypeList, setDownloadTypeList] = useState([]);
    const [disableDownloadButton, setDisableDownloadButton] = useState(true);
    const [showSendEMailDialog, setShowSendEMailDialog] = useState(false);
    const [clientNotes, setClientNotes] = useState("");
    const [siteAccountNotes, setSiteAccountNotes] = useState("");
    const [allFinanceEmails, setAllFinanceEmails] = useState(null);
    const [selectedToEmail, setSelectedToEmail] = useState(null);
    const [selectedToEmailList, setSelectedToEmailList] = useState(null);
    const [selectedToEmailError, setSelectedToEmailError] = useState(null);
    const [selectedCCEmail, setSelectedCCEmail] = useState(null);
    const [selectedCCEmailList, setSelectedCCEmailList] = useState(null);
    const [allToFinanceEmails, setAllToFinanceEmails] = useState(null);
    const [allCcFinanceEmails, setAllCcFinanceEmails] = useState(null);
    const [deleteEmailDialog, setDeleteEmailDialog] = useState(false);
    const [deleteEmailData, setDeleteEmailData] = useState(null);
    const [showAddFinanceEmailDialog, setShowAddFinanceEmailDialog] = useState(false);
    const [addedFinanceEmail, setAddedFinanceEmail] = useState("");
    const [addedFinanceEmailError, setAddedFinanceEmailError] = useState(false);
    const [addedRecipientType, setAddedRecipientType] = useState("");
    const [addedRecipientTypeError, setAddedRecipientTypeError] = useState(false);
    const [selectedAttachmentType, setSelectedAttachmentType] = useState(null);
    const [attachmentTypeList, setAttachmentTypeList] = useState([]);
    const [dialogLoading, setDialogLoading] = useState(false);
    const [disableSendInvoiceButton, setDisableSendInvoiceButton] = useState(false);
    const [sendInvoiceDialog, setSendInvoiceDialog] = useState(false);

    const [siteDataPage, setSiteDataPage] = useState(0);

    useEffect(() => {
        const currentDate = new Date();
        const previousDate = new Date(currentDate);
        previousDate.setDate(currentDate.getDate() - 2);
        setFromDate(previousDate);
        setToDate(currentDate);
        getSitesData(previousDate, currentDate);
    }, [])

    const getFormattedDate = (dateToFormat) => {
        const year = dateToFormat.getFullYear();
        const month = String(dateToFormat.getMonth() + 1).padStart(2, "0");
        const day = String(dateToFormat.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;
        return formatedDate;
    }

    const handleGo = () => {
        getSitesData(fromDate, toDate);
    }

    const handleFromDate = (e) => {
        const dateSelected = e.value;
        setFromDate(dateSelected);
        setMinToDate(dateSelected);
        setToDate(null);
        setDisableGoButton(true);
    }

    const handleToDate = (e) => {
        const dateSelected = e.value;
        setToDate(dateSelected);
        setDisableGoButton(false);
    }

    const getSitesData = (selectedFromDate, selectedToDate) => {
        setLoading(true);
        const endPoint = SERVICE_LOCATION + GET_PROCESSED_PAYAPP_MEASURESCOUNT_BY_SITE;
        const formatedFromDate = getFormattedDate(selectedFromDate);
        const formatedToDate = getFormattedDate(selectedToDate)
        const requestedData = {
            startDate: formatedFromDate,
            endDate: formatedToDate
        }
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            clearFilter();
            if (response.data.isSuccess) {
                const processedData = response.data.data.measuresCountBySite;
                var filteredByDepot = userDepot === "NONE" ? processedData : processedData.filter((item) => item.depotName === userDepot);
                setSitesData(filteredByDepot);
            }
            else if (!response.data.isSuccess) {
                setSitesData(null);
            }
        }).catch((error) => {
            setLoading(false)
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const getMeasuresData = (payAppNo) => {
        setLoading(true);
        const endPoint = SERVICE_LOCATION + GET_PROCESSED_PAYAPP_MEASURES_FOR_SITE;
        const requestedData = {
            systemId: payAppNo
        }
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            if (response.data.isSuccess) {
                setMeasuresData(response.data.data.invoicingMeasures);
            }
            else if (!response.data.isSuccess) {
                setMeasuresData(null);
            }
            setShowMeasures(true);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    // Site search functionality
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const clearFilter = () => {
        setFilters({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
        setGlobalFilterValue("");
    };

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="from-date">From</label>
                    <Calendar id="from-date" name="from-date" value={fromDate} onChange={handleFromDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="to-date">To</label>
                    <Calendar id="to-date" name="to-date" value={toDate} onChange={handleToDate} minDate={minToDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 padt-19">
                    <Button id="go" label="Go" disabled={disableGoButton} onClick={handleGo} />
                </div>
                <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 padt-15">
                    <div className="flex justify-content-end txt-right">
                        <Button className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const header = renderHeader();
    // Search site functionality Ends here  

    const handleDownloadPDF = () => {
        const paymentCardJobs = measuresData.filter(item => item.paymentCardIncluded === "Y").length;
        if (paymentCardJobs === 0 && downloadTypeList.length === 1 && downloadTypeList[0] === "PaymentCardOnly") {
            toast.current.show({ severity: "error", summary: "Error", detail: "No customer payment cards are available for the selected PayApp.", life: 3000 });
        }
        else {
            setLoading(true);
            const requestData = {
                payAppNo: selectedSite.payAppNo,
                downloadType: downloadTypeList
            }
            const endPoint = SERVICE_LOCATION + DOWNLOAD_INVOICE_WITH_DOWNLOAD_OPTIONS;
            axios.post(endPoint, requestData, {
                headers: {
                    Authorization: `Bearer ${data.data.token}`,
                },
            }).then((response) => {
                setLoading(false);
                if (response.data.isSuccess) {
                    if (response.data.data.downloadedInvoice.length > 0) {
                        (response.data.data.downloadedInvoice).forEach(workcard => {
                            const base64 = workcard.chunks.join("");
                            const base64String = "data:application/pdf;base64," + base64;
                            const linkSource = base64String;
                            const downloadLink = document.createElement("a");
                            const fileName = workcard.fileName;
                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                        });
                        setDownloadTypeList([]);
                        setSelectedDownloadType(null);
                        setDisableDownloadButton(true);
                    }
                    toast.current.show({ severity: "success", summary: "Success", detail: INVOICE_DOWNLOAD_SUCCESS, life: 5000 });
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
                }
            }).catch((error) => {
                setLoading(false);
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
            })
        }
    }

    const handleDownloadTypeSelection = (e) => {
        const selectedList = e.value;
        setSelectedDownloadType(selectedList);
        const docs = selectedList.map(item => item.downloadType);
        setDownloadTypeList(docs);
        setDisableDownloadButton(false);
    }

    const handleAttachmentTypeSelection = (e) => {
        const selectedList = e.value;
        setSelectedAttachmentType(selectedList);
        const docs = selectedList.map(item => item.downloadType);
        setAttachmentTypeList(docs);
    }

    const handleOkToSendInvoice = () => {
        setDisableSendInvoiceButton(true);
        setSelectedToEmailError(false);
        setDialogLoading(true);
        setSendInvoiceDialog(false);
        const requestedData = {
            AppNo: selectedSite.payAppNo,
            ToEmails: selectedToEmailList,
            CcEmails: selectedCCEmailList === null ? [] : selectedCCEmailList,
            FinanceEmailList: allFinanceEmails,
            Attachments: attachmentTypeList
        };
        const endPoint = SERVICE_LOCATION + SEND_INVOICE;
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setDialogLoading(false);
            if (response.data.isSuccess) {
                getSitesData(fromDate, toDate);
                setShowMeasures(false);
                setShowSendEMailDialog(false);
                setDisableSendInvoiceButton(false);
                handleHideSendEmailDialog();
                toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 5000 });
            }
            if (!response.data.isSuccess) {
                setDisableSendInvoiceButton(false);
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
            }
        }).catch((error) => {
            setDialogLoading(false);
            setDisableSendInvoiceButton(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const handleSendInvoice = () => {
        if (selectedToEmailList === null || selectedToEmailList.length === 0) {
            setSelectedToEmailError(true);
        }
        else if (attachmentTypeList.length === 0) {
            setSendInvoiceDialog(true);
        }
        else {
            handleOkToSendInvoice();
        }
    }

    const handleHideSendEmailDialog = () => {
        setShowSendEMailDialog(false);
        setSelectedToEmail(null);
        setSelectedToEmailList(null);
        setSelectedCCEmail(null);
        setSelectedCCEmailList(null);
        setAllCcFinanceEmails(null);
        setAllToFinanceEmails(null);
        setSelectedToEmailError(false);
    }

    const handleShowSendEmailDialog = () => {
        if (measuresData.length > 0) {
            const measData = measuresData[0];
            var financeEmails = [];
            var emailIndex = 1;

            const resultClientFinanceEmails = JSON.parse(measData.clientFinanceEmail);
            const resultSiteFinanceEmails = JSON.parse(measData.siteFinanceEmail);

            resultClientFinanceEmails.forEach(cliEmail => {
                const objEmail = {
                    id: emailIndex,
                    email: cliEmail,
                    recipientType: "client",
                    isAddEmail: false
                }
                financeEmails.push(objEmail);
                emailIndex++;
            });

            resultSiteFinanceEmails.forEach(siteEmail => {
                const objEmail = {
                    id: emailIndex,
                    email: siteEmail,
                    recipientType: "site",
                    isAddEmail: false
                }
                financeEmails.push(objEmail);
                emailIndex++;
            });

            setClientNotes(measData.clientNotes);
            setSiteAccountNotes(measData.siteAccountNotes);
            setAllFinanceEmails(financeEmails);
            setAllToFinanceEmails(financeEmails);
            setAllCcFinanceEmails(financeEmails);
            setShowSendEMailDialog(true);
        }
    }

    const sendEmailfooterContent = (
        <div>
            <PrimeButton label="Cancel" size="small" onClick={handleHideSendEmailDialog} disabled={disableSendInvoiceButton} severity="secondary" outlined />
            <PrimeButton label="Send" size="small" onClick={handleSendInvoice} disabled={disableSendInvoiceButton} severity="primary" />
        </div>
    );

    const renderDownloaderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                    <div className="flex flex-column gap-2 fitter-feild">
                        <MultiSelect value={selectedDownloadType} onChange={handleDownloadTypeSelection} options={INVOICE_DOWNLOAD_TYPES} optionLabel="downloadType"
                            placeholder="Select Download PDF" maxSelectedLabels={3} className="w-full md:w-14rem" display="chip" />
                    </div>
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <Button id="download" label="Download Invoice" disabled={disableDownloadButton} onClick={handleDownloadPDF} />
                </div>

                <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-7">
                    <div className="flex justify-content-end txt-right">
                        <Button id="send-invoice" label="Send Invoice" onClick={handleShowSendEmailDialog} />
                    </div>
                </div>
            </div>
        )
    }

    const downloaderHeader = renderDownloaderHeader();

    const onRowSelect = (e) => {
        setSelectedSite(e.data);
        getMeasuresData(e.data.payAppNo);
    }

    const handleBackToAccounts = () => {
        setMeasuresData(null);
        setShowMeasures(false);
        setSelectedDownloadType(null);
        setDownloadTypeList([]);
        setDisableDownloadButton(true);
    }

    const handleEmailToSelection = (e) => {
        const selectedEmails = e.value;
        setSelectedToEmail(selectedEmails);
        const emailList = selectedEmails.map(doc => doc.email);
        setSelectedToEmailList(emailList);

        const updatedArray = allFinanceEmails.filter(
            (item) => !selectedEmails.some((removeItem) => removeItem.id === item.id)
        );
        setAllCcFinanceEmails(updatedArray)
    }

    const handleEmailCCSelection = (e) => {
        const selectedEmails = e.value;
        setSelectedCCEmail(selectedEmails);
        const emailList = selectedEmails.map(doc => doc.email);
        setSelectedCCEmailList(emailList);

        const updatedArray = allFinanceEmails.filter(
            (item) => !selectedEmails.some((removeItem) => removeItem.id === item.id)
        );
        setAllToFinanceEmails(updatedArray)
    }

    const onHideAddFinanceEmailDialog = () => {
        setShowAddFinanceEmailDialog(false);
        setAddedFinanceEmail("");
        setAddedRecipientType(null);
        setAddedFinanceEmailError(false);
        setAddedRecipientTypeError(false);
    }

    const handleOnAddFinanceEmail = () => {
        var selectedRecipient = addedRecipientType.type;
        addedFinanceEmail === "" ? setAddedFinanceEmailError(true) : setAddedFinanceEmailError(false);
        selectedRecipient === "" ? setAddedRecipientTypeError(true) : setAddedRecipientTypeError(false);
        if (addedFinanceEmail !== "" || selectedRecipient !== "") {
            var allEmails = allFinanceEmails
            const maxId = allEmails.reduce((max, obj) => (obj.id > max ? obj.id : max), 0)
            const finanEmail = {
                id: maxId + 1,
                email: addedFinanceEmail,
                recipientType: selectedRecipient,
                isAddEmail: true
            }

            if (!allEmails.some(item => item.email === addedFinanceEmail)) {
                allEmails.push(finanEmail);
                setAllFinanceEmails(allEmails);
            }

            var allToEmails = allToFinanceEmails;
            if (!allToEmails.some(item => item.email === addedFinanceEmail)) {
                allToEmails.push(finanEmail);
                setAllToFinanceEmails(allToEmails);
            }

            var allCcEmails = allCcFinanceEmails;
            if (!allCcEmails.some(item => item.email === addedFinanceEmail)) {
                allCcEmails.push(finanEmail);
                setAllCcFinanceEmails(allCcEmails);
            }

            setShowAddFinanceEmailDialog(false);
            setAddedFinanceEmail("");
            setAddedRecipientType(null);
        }
    }

    const financeEmailHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <Button id="add-finace-email" label="Add Finance Email" onClick={() => setShowAddFinanceEmailDialog(true)} />
                </div>
            </div>
        )
    }

    const addFinanceEmailFooterContent = (
        <div>
            <PrimeButton label="Cancel" size="small" onClick={onHideAddFinanceEmailDialog} severity="secondary" outlined />
            <PrimeButton label="Add" size="small" onClick={handleOnAddFinanceEmail} severity="secondary" outlined />
        </div>
    );

    const confirmDeleteEmail = (rowData) => {
        setDeleteEmailDialog(true);
        setDeleteEmailData(rowData);
    }

    const handleDeleteEmail = () => {
        let allEmails = allFinanceEmails.filter((val) => val.id !== deleteEmailData.id);
        let allToEmails = allToFinanceEmails.filter((val) => val.id !== deleteEmailData.id);
        let allCcEmails = allCcFinanceEmails.filter((val) => val.id !== deleteEmailData.id);
        setAllFinanceEmails(allEmails);
        setAllToFinanceEmails(allToEmails);
        setAllCcFinanceEmails(allCcEmails);
        toast.current.show({ severity: "success", summary: "Success", detail: "succesfully deleted the newly created email", life: 3000 });
        setDeleteEmailDialog(false);
    }

    const deleteEmailDialogFooter = (
        <div>
            <PrimeButton label="No" size="small" onClick={() => setDeleteEmailDialog(false)} severity="secondary" outlined />
            <PrimeButton label="Yes" size="small" onClick={handleDeleteEmail} severity="danger" outlined />
        </div>
    );

    const deleteEmailBodyTemplate = (rowData) => {
        if (rowData.isAddEmail) {
            return (
                <div>
                    <PrimeButton icon="pi pi-trash" rounded outlined severity="danger" onClick={() => confirmDeleteEmail(rowData)} />
                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    };

    const sendInvoiceDialogFooter = (
        <div>
            <PrimeButton label="No" size="small" onClick={() => setSendInvoiceDialog(false)} severity="secondary" outlined />
            <PrimeButton label="Yes" size="small" onClick={handleOkToSendInvoice} severity="danger" outlined />
        </div>
    );

    const sitesTablePageChange = (event) => {
        setSiteDataPage(event.first / event.rows);
    };

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }
            <Toast ref={toast} />

            {!showMeasures &&
                <div className="worksheets-section">
                    <h4>Processed Pay App</h4>
                    <DataTable className="font-12" value={sitesData} datakey="systemId" paginator rows={10} first={siteDataPage * 10}
                        onPage={sitesTablePageChange} metaKeySelection={false} filters={filters} header={header}
                        selectionMode="single" selection={selectedSite} onSelectionChange={(e) => setSelectedSite(e.value)}
                        onRowSelect={onRowSelect}
                        globalFilterFields={["clientAccount", "clientName", "site", "contractType", "systemId", "siteRefNo", "depot", "depotName",
                            "payAppNo", "siteApplicationNumber", "sageInvoice", "invoiceDate", "totalRevenue", "taxCode", "taxRate",
                            "createdDate", "createdBy", "measuresCount"]}
                        scrollable tableStyle={{ minWidth: "150rem" }} emptyMessage="No processed payapp accounts available.">
                        <Column field="clientAccount" header="Client Account"></Column>
                        <Column field="clientName" header="Client Name"></Column>
                        <Column field="site" header="Site"></Column>
                        <Column field="contractType" header="ContractType"></Column>
                        <Column field="systemId" header="SystemId" hidden></Column>
                        <Column field="siteRefNo" header="Site RefNo"></Column>
                        <Column field="depot" header="DepotCode" hidden></Column>
                        <Column field="depotName" header="Depot" hidden></Column>
                        <Column field="payAppNo" header="Sales Order"></Column>
                        <Column field="siteApplicationNumber" header="Site App No"></Column>
                        <Column field="sageInvoice" header="Sage Invoice"></Column>
                        <Column field="invoiceDate" header="Invoice Date"></Column>
                        <Column field="totalRevenue" header="Total Revenue(£)"></Column>
                        <Column field="taxCode" header="Tax Code"></Column>
                        <Column field="taxRate" header="Tax Rate(%)"></Column>
                        <Column field="createdDate" header="Created"></Column>
                        <Column field="createdBy" header="Created By"></Column>
                        <Column field="measuresCount" header="Measures"></Column>
                    </DataTable>
                </div>
            }

            {showMeasures &&
                <div className="worksheets-section">
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padt-10 txt-bold">
                            {selectedSite.clientAccount} - {selectedSite.site}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div className="flex justify-content-end txt-right" onClick={handleBackToAccounts}>
                                <Button id="back" label="Back to Accounts" link onClick={handleBackToAccounts} />
                            </div>
                        </div>
                    </div>
                    <DataTable className="font-12" value={measuresData} dataKey="measureId" paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                        tableStyle={{ minWidth: "50rem" }} emptyMessage="No processed accounts available to view." header={downloaderHeader}>
                        <Column field="site" header="Site" hidden></Column>
                        <Column field="worksheetNo" header="WorksheetNo" hidden></Column>
                        <Column field="plotId" header="SystemId" hidden></Column>
                        <Column field="plotNo" header="Plot"></Column>
                        <Column field="plotDescription" header="PlotDescription"></Column>
                        <Column field="product" header="Measure"></Column>
                        <Column field="measureId" header="MeasureId"></Column>
                        <Column field="quantity" header="Quantity"></Column>
                        <Column field="revenue" header="Revenue(£)"></Column>
                        <Column field="paymentCardRequired" header="PaymentCardRequired"></Column>
                        <Column field="paymentCardIncluded" header="PaymentCardIncluded"></Column>
                    </DataTable>
                </div>
            }

            <Dialog header="Select Recipient" style={{ width: "50vw" }} visible={showSendEMailDialog} onHide={handleHideSendEmailDialog} footer={sendEmailfooterContent}>
                <div className={`pdf-viewer ${dialogLoading ? "disabled" : ""}`}>
                    {
                        dialogLoading &&
                        <div className="spinner-overlay">
                            <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                        </div>
                    }

                    <div className="row padb-20">
                        <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                            <label htmlFor="clientNotes">Client Notes:</label>
                        </div>
                        <div className="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9 padr-20">
                            <InputTextarea disabled value={clientNotes} onChange={(e) => setClientNotes(e.value)} style={{ width: "100%", height: "100%" }} autoResize />
                        </div>
                    </div>
                    <div className="row padb-20">
                        <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                            <label htmlFor="siteAccountNotes">Site Account Notes:</label>
                        </div>
                        <div className="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9 padr-20">
                            <InputTextarea disabled value={siteAccountNotes} onChange={(e) => setSiteAccountNotes(e.value)} style={{ width: "100%", height: "100%" }} autoResize />
                        </div>
                    </div>
                    <div className="row padb-20">
                        <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                            <label htmlFor="emailTo">Email To:</label>
                        </div>
                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <MultiSelect value={selectedToEmail} onChange={handleEmailToSelection} options={allToFinanceEmails} optionLabel="email"
                                    placeholder="Select Email" maxSelectedLabels={3} className="w-full md:w-14rem" display="chip" />
                            </div>
                            {selectedToEmailError && <small className="p-error  padb-10">This field is required</small>}
                        </div>
                    </div>
                    <div className="row padb-20">
                        <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                            <label htmlFor="emailTo">CC:</label>
                        </div>
                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <MultiSelect value={selectedCCEmail} onChange={handleEmailCCSelection} options={allCcFinanceEmails} optionLabel="email"
                                    placeholder="Select CC" maxSelectedLabels={3} className="w-full md:w-14rem" display="chip" />
                            </div>
                        </div>
                    </div>
                    <div className="row padb-20">
                        <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                            <label htmlFor="emailTo">Attachment:</label>
                        </div>
                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <MultiSelect value={selectedAttachmentType} onChange={handleAttachmentTypeSelection} options={INVOICE_DOWNLOAD_TYPES} optionLabel="downloadType"
                                    placeholder="Select Download PDF" maxSelectedLabels={3} className="w-full md:w-14rem" display="chip" />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <DataTable className="font-12" value={allFinanceEmails} selectionMode="checkbox" header={financeEmailHeader} scrollable dataKey="id"
                                tableStyle={{ minWidth: "40rem" }} emptyMessage="No Finance emails availabe">
                                <Column field="id" header="Id" className="table-header" hidden></Column>
                                <Column field="email" header="Email" className="table-header"></Column>
                                <Column field="recipientType" header="Recipient Type" className="table-header"></Column>
                                <Column body={deleteEmailBodyTemplate} header="Delete" headerStyle={{ width: "3rem" }} exportable={false}></Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={deleteEmailDialog} style={{ width: "20vw" }} header="Confirm" modal footer={deleteEmailDialogFooter} onHide={() => setDeleteEmailDialog(false)}>
                <div className="confirmation-content">
                    {deleteEmailData && (
                        <span>
                            Are you sure you want to delete the contact for <b>{deleteEmailData.email}</b>?
                        </span>
                    )}
                </div>
            </Dialog>

            <Dialog header="Add Finance Email" style={{ width: "40vw" }} visible={showAddFinanceEmailDialog} onHide={onHideAddFinanceEmailDialog} footer={addFinanceEmailFooterContent}>
                <div>
                    <div className="row padb-20">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                            <label htmlFor="addedFinanceEmail">Email</label>
                        </div>
                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 padr-20">
                            <InputText keyfilter="email" type="email" value={addedFinanceEmail} id="addedFinanceEmail" onChange={(e) => setAddedFinanceEmail(e.target.value)} className="p-inputtext-sm input-text-width-height" />
                            {addedFinanceEmailError && <small className="p-error  padb-10">This field is required</small>}
                        </div>
                    </div>

                    <div className="row padb-20">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                            <label htmlFor="recipientType">Recipient Type</label>
                        </div>
                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 padr-20">
                            <div>
                                <Dropdown value={addedRecipientType} onChange={(e) => setAddedRecipientType(e.value)} options={RECIPIENT_TYPES} optionLabel="type"
                                    placeholder="Select Recipient Type" className="w-full md:w-14rem" />
                            </div>
                            {addedRecipientTypeError && <small className="p-error padb-10">This field is required</small>}
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={sendInvoiceDialog} style={{ width: "30vw" }} header="Confirm" modal footer={sendInvoiceDialogFooter} onHide={() => setSendInvoiceDialog(false)}>
                <div className="confirmation-content">
                    <span>
                        Are you sure you want to send the invoice without attaching any files?
                    </span>
                </div>
            </Dialog>
        </div>
    )
}

export default ProcessedPayApps;